<!--
  @description IT设备管理
  @author xiehan
  @date 2018/12/07
-->
<template>
  <div class="ITDevice__content">
    <el-form ref="searchForm" :model="searchForm" :inline="true" input-width="180px">
      <el-form-item :label="$t('ITDevice.siteName')">
        <g-select :default-all="true" v-model="searchForm.site" :list="select_site"></g-select>
      </el-form-item>
      <el-form-item :label="$t('ITDevice.devType')">
        <g-select :default-all="true" v-model="searchForm.devType" :list="select_dev"></g-select>
      </el-form-item>
      <el-form-item :label="$t('ITDevice.devIp')">
        <g-select :default-all="true" v-model="searchForm.ip" :list="select_ip"></g-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" 
          @click="e_searchTable"
          v-g-rac="gRac('ITDevice_search')"
          v-text="$t('common.search')"></el-button>
        <el-button type="primary" 
          @click="jump2ITDeviceMonitor"
          v-g-rac="gRac('ITDevice_monitor')"
          v-text="$t('ITDevice.monitor')"></el-button>
      </el-form-item>
      <div>
        <el-form-item>
          <el-button type="primary" 
            v-g-rac="gRac('ITDevice_add')"
            @click="handlerDevice('add')"
            v-text="$t('common.add')"></el-button>
        </el-form-item>
      </div>
    </el-form>
    <el-table-extend
      :data="tData" 
      :head="tHead" 
      :currentChange="tCurrentChange" 
      :sizeChange="tSizeChange" 
      border>
      <template slot="control-column" slot-scope="{data}">
        <el-table-extend-control 
          :control="tableControl" 
          :data="data" 
          :label="$t('common.handle')">
        </el-table-extend-control>
      </template>
    </el-table-extend>
    <el-dialog :closeOnClickModal="false"
      :title="handlerDialogTitle"
      :visible.sync="handlerDialogVisible"
      width="400px">
      <el-form ref="handleForm" :model="handleForm" input-width="180px" label-width="90px" :rules="rules">
        <el-form-item 
          v-for="(item, index) in handleForm" 
          :label="$t('ITDevice.' + index)" 
          :key="index" 
          :prop="index">
          <g-select
            v-model="handleForm[index]"
            v-if="index === 'siteName'"
            :list="select_site"
            @change="siteNameChange">
          </g-select>
          <g-select
            v-model="handleForm[index]"
            v-else-if="index === 'devType'"
            :list="select_dev">
          </g-select>
          <el-input 
            :disabled="index === 'siteCode'" 
            v-model="handleForm[index]" 
            v-else></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handlerDialogVisible = false" v-text="$t('common.cancel')"></el-button>
        <el-button type="primary" @click="confirmHandler" v-text="$t('common.confirm')"></el-button>
      </span>
    </el-dialog>
    <el-dialog :closeOnClickModal="false"
      :title="$t('common.detail')"
      :visible.sync="detailDialogVisible"
      width="400px">
      <el-form ref="detailForm" :model="detailForm" input-width="auto" label-width="80px">
        <el-form-item v-for="(item, index) in detailForm" :label="$t('ITDevice.' + index)" :key="index">
          <span v-text="detailForm[index]"></span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false" v-text="$t('common.close')"></el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import rac from '@/plugins/rac-mixin'
  import dic from '@/components/mixins/dic'
  import table from '@/components/mixins/table'
  import cmdbBiz from '@/logic/cmdb/cmdbBiz'
  import ITDeviceBiz from '@/logic/cmdb/ITDeviceBiz'
  import { extend } from '@/utils/tool'
  import tab from '@/views/layout/components/setTab'
  export default {
    mixins: [rac, dic, table],
    data () {
      return {
        select_site: {},
        select_dev: {},
        select_ip: {},
        searchForm: {
          site: '',
          devType: '',
          ip: ''
        },
        handleForm: {
          siteName: '',
          siteCode: '',
          cabinetCode: '',
          devType: '',
          name: '',
          ip: '',
          snmpAccount: '',
          authProtocol: '',
          authPassword: '',
          privProtocol: '',
          privPassword: '',
          contact: '',
          phone: '',
          remarks: ''
        },
        rules: {},
        detailForm: {
          siteName: '',
          cabinetCode: '',
          devType: '',
          name: '',
          ip: '',
          contact: '',
          phone: '',
          remarks: ''
        },
        tableControl: [
          {
            label: this.$t('common.delete'),
            callback: (row, index, data) => {
              this.$confirm(this.$t('common.deleteTips'), this.$t('common.delete'), {
                confirmButtonText: this.$t('common.confirm'),
                cancelButtonText: this.$t('common.cancel'),
                type: 'warning'
              }).then(() => {
                ITDeviceBiz.deleteDevice({ id: row.id }).then(() => {
                  this.successMessage()
                  this.searchTable()
                })
              }).catch(() => {})
            },
            rac: () => this.gRac('ITDevice_delete')
          },
          {
            label: this.$t('common.edit'),
            callback: (row, index, data) => {
              this.selectId = row.id
              this.handlerDevice('edit', row.id)
            },
            rac: () => this.gRac('ITDevice_amend')
          },
          {
            label: this.$t('common.check'),
            callback: (row, index, data) => {
              for (let i in this.detailForm) {
                this.detailForm[i] = row[i]
              }
              this.detailDialogVisible = true
            },
            rac: () => this.gRac('ITDevice_detail')
          }
        ],
        detailDialogVisible: false,
        handlerDialogVisible: false,
        handlerDialogTitle: this.$t('ITDevice.addDevice'),
        isEdit: false,
        selectId: ''
      }
    },
    methods: {
      successMessage () {
        this.$message({
          message: this.$t('common.success'),
          type: 'success'
        })
      },
      getSiteList () {
        cmdbBiz.siteNameList().then(data => {
          this.select_site = data
          this.handleForm.siteName = Object.keys(this.select_site)[0]
        })
      },
      siteNameChange (val) {
        this.handleForm.siteCode = val.key
      },
      getIpList () {
        ITDeviceBiz.getDeviceIP().then(data => {
          let ipObj = {}
          data.map(item => {
            ipObj[item] = item
          })
          this.select_ip = ipObj
        })
      },
      async getDevType () {
        await this.dGetDictionaryByCode('ITDeviceType')
        this.select_dev = { ...this.dDictionary.ITDeviceType }
        this.getSiteList()
        this.getIpList()
        this.searchTable()
        this.initTable()
        this.handleForm.devType = Object.keys(this.select_dev)[0]
      },
      setRules () {
        this.rules = {}
        for (let i in this.handleForm) {
          this.rules[i] = [
            { required: true, message: `${this.$t('common.entryTips')}${this.$t('ITDevice.' + i)}` }
          ]
        }
        delete this.rules.contact
        delete this.rules.phone
        delete this.rules.remarks
      },
      initTable () {
        this.tInitTable({
          lanKey: 'ITDevice.table',
          head: ['siteName', 'cabinetCode', 'devType', 'name', 'ip'],
          requestFun: this.searchTable,
          headOpt: {
            devType: {
              formatter: 'Dictionary',
              formatterDic: this.select_dev
            }
          }
        })
      },
      e_searchTable () {
        this.tResetPage()
        this.searchTable()
      },
      jump2ITDeviceMonitor () {
        this.$router.push({ name: 'ITDeviceMonitor' })
        tab.selectTab('ITDeviceMonitor')
      },
      searchTable () {
        const reqData = extend(true, { ...this.tPageInfo }, this.searchForm)
        ITDeviceBiz.getDevice(reqData).then((data) => {
          this.tData = data
        })
      },
      handlerDevice (name, id) {
        this.isEdit = (name === 'edit')
        this.handlerDialogVisible = true
        this.$nextTick(() => {
          if (this.isEdit) {
            ITDeviceBiz.getPassword({ id: id }).then(data => {
              for (let i in this.handleForm) {
                this.handleForm[i] = data[i]
              }
            })
          } else {
            this.$refs['handleForm'].clearValidate()
            this.$refs['handleForm'].resetFields()
            this.handleForm.siteCode = this.handleForm.siteName
          }
        })
      },
      confirmHandler () {
        this.$refs['handleForm'].validate((valid) => {
          if (valid) {
            let eventName = this.isEdit ? 'changeDevice' : 'addDevice'
            let saveObj = extend(true, {}, this.handleForm)
            if (this.isEdit) saveObj.id = this.selectId
            delete saveObj.siteName
            ITDeviceBiz[eventName](saveObj).then(data => {
              this.handlerDialogVisible = false
              this.searchTable()
            })
          } else {
            return false
          }
        })
      }
    },
    watch: {
      isEdit (val) {
        this.handlerDialogTitle = val ? this.$t('ITDevice.editDevice') : this.$t('ITDevice.addDevice')
      }
    },
    mounted () {
      this.getDevType()
      this.setRules()
    }
  }
</script>

<style>

</style>